// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_tHk","requiredAsterisk":"Info_requiredAsterisk__3-rN0"};